



















import Vue from "vue";

import iwInputToggle from "@/encoding/components/buildingBlocks/InputToggle.vue";
import {addDefaultValuesToStore, killNotRelevantCriteria, resetPricingPack} from "@/shared/scripts/ValidateData";
import { mapActions } from "vuex";
import { getSteps } from "@/encoding/scripts/steps";

export default Vue.extend({
    components: {
        iwInputToggle: iwInputToggle,
    },

    props: {
        isCentered: {
            type: Boolean,
            default: false,
            required: false
        },
        inputLabelVisible: {
            type: Boolean,
            default: true,
            required: false
        }
    },

    data: function() {
        return {
            pathInStore: "transaction.type"
        };
    },
    computed: {
        transactionType: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStore);
        },
        isEditionMode: function(): boolean {
            return this.$store.getters["FormModule/getIsEditionMode"];
        },
        applyAndResetWizard: function(): boolean {
            return this.$store.getters["ResetWizardModule/getApplyChange"]("type_of_transaction");
        },
        getFirstPublicationDate: function(): string|null  {
            return this.$store.getters["FormModule/getFirstPublicationDate"];
        }
    },
    watch: {
        applyAndResetWizard: function(value) {
            if(value) {
                (this.$refs.inputToggle as Vue & { actionClick: () => void }).actionClick();
            }
        }
    },
    mounted: function() {
        if (this.transactionType == null) {
            this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": "FOR_SALE"});

            // set transaction subtype automaticallt depending on transaction type (only for particlar user, won't allow notary sale or life annuity)
            this.$store.dispatch("FormModule/addValue", {"path": "transaction.subtype", "value": "BUY_REGULAR"});
        }
    },
    methods: {
        ...mapActions({
            resetValidatedSteps: "StepsWizard/reset",
            setInitialSteps: "StepsWizard/init",
        }),
        handleClick: function() {
            if (this.getFirstPublicationDate) {
                return;
            }
            if(this.$store.getters["StepsWizard/getIndexVisited"] > 4 && !this.applyAndResetWizard) {
                this.$store.commit("ResetWizardModule/setField", "type_of_transaction");
                this.$store.commit("ModalModule/openResetWizardModal");
            } else {
                (this.$refs.inputToggle as Vue & { actionClick: () => void }).actionClick();
            }
        },
        updateTransactionType: function(transactionType: string) {
        
            this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": transactionType});

            // set transaction subtype automatically depending on transaction type (only for particular users, won't allow notary sale or life annuity)
            this.$store.dispatch("FormModule/addValue", {"path": "transaction.subtype", "value": transactionType == "FOR_SALE" ? "BUY_REGULAR" : "RENT_REGULAR"});

            let propertySubtype: string = this.$store.getters["FormModule/getValue"]("property.subtype") || "";
            let transactionSubtype: string = this.$store.getters["FormModule/getValue"]("transaction.subtype") || "";

            this.setInitialSteps({config: getSteps()});
            
            if(this.applyAndResetWizard) {
                this.$store.commit("ResetWizardModule/setApplyChange", false);
                this.resetValidatedSteps(["step-property-type"]);
            }
            

            this.killAndSetValues(this.getPropertyType(), propertySubtype, transactionType, transactionSubtype);
        },
        killAndSetValues: async function(propertyType: string, propertySubtype: string, transactionType: string, transactionSubtype: string) {
            killNotRelevantCriteria(propertyType, propertySubtype, transactionType, transactionSubtype);
            addDefaultValuesToStore(propertyType, propertySubtype, transactionType, transactionSubtype);
            resetPricingPack();
        }
    }
});

